<section class="searchTotal"
         #searchTotalRow
         [hidden]="!gridConfigItems || gridConfigItems.hideFilters">
    <div class="col-md-12 no-padding-right-left"
         [hidden]="!gridOptions">
        <div class="d-flex align-items-end">
            <div class="padding-left-0 {{searchClass}}">
                <div class="input-group" [ngStyle]="{'display': searchClass == 'col-md-0' ? 'none' : ''}">
                    <input type="text"
                           class="form-control searchField padding-right-20"
                           required=""
                           #searchField
                           [ngClass]="{'has-value': searchField.value}"
                           (input)="onGridSearchTextChange(searchField.value)"
                           name="searchText"
                           [(ngModel)]="searchText">
                    <label for="searchText">{{ 'label_search_criterion' | translate:param }}</label>
                    <span class="icons"><a><i class="fas fa-search"
                               aria-hidden="true"></i></a></span>
                </div>
            </div>
            <div class="text-right" *ngIf="this.dataFilterItems && this.dataFilterItems.length > 0"
                [ngClass]="dropDownClass">
               <div class="input-group"
                    *ngIf="dataFilterItems"
                    [ngStyle]="{'display': dataFilterItems && dataFilterItems.length > 0 ? '' : 'none'}">
                   <ng-select class="solo-dropdown filterDropdown"
                              [items]="dataFilterItems"
                              bindLabel="name"
                              bindValue="id"
                              [placeholder]="gridConfigItems.dataFilterTitle"
                              [clearable]="false"
                              [selectOnTab]="true"
                              [(ngModel)]="gridConfigItems.dataFilterValue"
                              (change)="onDataFilterChange(gridConfigItems.dataFilterValue,'')"
                              notFoundText="{{ 'no_data_available' | translate: param }}">
                   </ng-select>
               </div>
           </div>
            <div class="text-right" *ngIf="this.gridFilterItems && this.gridFilterItems.length > 0  && gridConfigItems.gridFilterPanelConfig == null"
                 [ngClass]="dropDownClass">
                <div class="input-group"
                     *ngIf="gridConfigItems"
                     [ngStyle]="{'display': gridFilterItems && gridFilterItems.length > 0 ? '' : 'none'}">
                    <ng-select class="solo-dropdown filterDropdown"
                               [items]="gridFilterItems"
                               bindLabel="name"
                               bindValue="id"
                               placeholder="{{ 'label_filter' | translate:param }}"
                               [clearable]="false"
                               [selectOnTab]="true"
                               [(ngModel)]="gridConfigItems.statusValue"
                               (change)="statusChange(gridConfigItems.statusValue,'')"
                               notFoundText="{{ 'no_data_available' | translate: param }}">
                    </ng-select>
                </div>
            </div>
            <div class="col-md-5" *ngIf ="buttonFilterItem" style="margin-top: -14px;">
                <small class="d-block mb-1">{{"filter_by"| translate }}</small>
                <div class="d-flex">
                    <button class="btn btn-sm eod-btn-outline-primary mr-2" [ngClass]="{'active': selectedFilter == 8}" (click)="onDataFilterChange(8, '')">{{"all"| translate }}</button>
                    <button class="btn btn-sm eod-btn-outline-primary mr-2 " [ngClass]="{'active': selectedFilter == 6}" (click)="onDataFilterChange(6, '')">{{"corporate_credit_card"| translate }}</button>
                    <button class="btn btn-sm eod-btn-outline-primary" [ngClass]="{'active': selectedFilter == 1}" (click)="onDataFilterChange(1, '')">{{"cash_personalcredit_debitcard"| translate }}</button>
                </div>
            </div>
            
           <div *ngIf="gridConfigItems && gridConfigItems.gridFilterPanelConfig != null" class="input-group z-103 ml-3">
            <input type="text" readonly="" class="form-control searchField padding-right-30 has-value"
                  (click)="showFilterPanel = true;" [value]="getFilterValue()"><label for="InputPanel">{{
                  'Filter By' | translate }}</label><span class="icons z-0 ng-star-inserted"><a><i
                      aria-hidden="true" class="fas fa-chevron-circle-right text-logo-blue"></i></a></span>
           </div>
            <div [ngClass]="calendarClass" *ngIf="fromDateFilter">

                <div class="input-group d-flex align-items-end"
                     [ngStyle]="{'display': fromDateFilter ? '' : 'none'}">
                    <input class="form-control has-value"
                           #fFrmDate
                           [(ngModel)]="this.nrfcConfigModel.fromDate"
                           (input)="onFromDateChange($event.target.value)" />
                    <label for="fromSetDate">
                        {{ 'start_date' | translate:param }}
                    </label>
                    <app-calendar-icon></app-calendar-icon>
                </div>

            </div>
            <div class="col-lg-2 col-md-2 col-sm-2" *ngIf="showAdvancedSearch" >

                <p class="padding-left-10  padding-top-10 text-underline cursor-pointer text-logo-blue" (click)="showAdvanceSearchPanel()">
                    {{"advance_search" | translate}} </p>
                    <p class="position-relative">
                    
                    <small *ngIf="advanceSearchAlphabet!=''" class="color-grey padding-left-10 cursor-default" >({{"letter_filter" | translate}} "{{advanceSearchAlphabet}}" - <a  style="color: #29b7e9; cursor: pointer;text-decoration: underline;" class="text-underline" (click)="clearAdvanceSearch()">{{"clear_filter" | translate}}</a>)</small>
                </p>



            </div>
            <div class="text-right table-total"
                 [ngClass]="counterDivClass"
                 *ngIf="gridConfigItems">
                <div [ngStyle]="{'display': gridConfigItems.countByStatus > 0 ? '' : 'none'}"
                     *ngFor="let item of gridConfigItems.countByStatus"
                     [ngClass]="item.className">
                    <span (click)="statusChange('',item)">{{item.label | translate:param}}<span
                              *ngIf="item.count!= null">:</span>
                        {{item.count}}</span>
                </div>
          
            </div>
        </div>
    </div>
</section>
<div *ngIf="gridConfigItems && (gridConfigItems.gridTitle || gridConfigItems.gridTitleHyperlink)">
    <!-- <h6 class="fw-600" [ngClass]="gridConfigItems.gridTitleClass">{{gridConfigItems.gridTitle | translate:param}}</h6> -->
    <h6 class="fw-600" [ngClass]="gridConfigItems.gridTitleClass">
        {{gridConfigItems.gridTitle | translate:param}}
        <span class="eod-link-primary"
              (click)="fnOnGridTitleHyperlinkClick($event)">
            {{gridConfigItems.gridTitleHyperlink | translate:param}}
        </span>
    </h6>
</div>

<div class="eod-tab-old border-top pt-3 px-3 pb-3 eod-bg-grey-05" *ngIf="gridConfigItems && gridConfigItems.gridTabConfig && gridConfigItems.statusValue == gridConfigItems.gridTabConfig.showWhenStatusValue">
    <ul class="nav nav-pills" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation" *ngFor="let tab of gridConfigItems.gridTabConfig.tabs; let i = index">
            <button class="nav-link" [ngClass]="{'active': tab.isActive}" 
                type="button" role="tab" 
                (click)="onTabClick(tab)">
                {{ tab.label | translate : param }} ({{ tab.count }})
            </button>
        </li>
    </ul>
</div>


<!-- <div class="tabs-container px-2 mb-2" id="billing" *ngIf="gridConfigItems && gridConfigItems.statusValue == ExpenseStatusEnum.IncompleteCardExpense">
  <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <a class="nav-item nav-link active" id="nav-newItems-tab" data-bs-toggle="tab" role="tab"
        aria-controls="nav-newItems" aria-selected="false" data-bs-target="#nav-newItems" aria-controls="nav-newItems"
        (click)="statusChange(ExpenseStatusEnum.CCExpenseMatchedWithReceipt, null)">
        {{ "Matched With Receipts" | translate : param }}</a>
      <a class="nav-item nav-link" id="nav-previouslyExported-tab" data-bs-toggle="tab" role="tab"
        aria-controls="nav-previouslyExported" aria-selected="false" data-bs-target="#nav-previouslyExported"
        aria-controls="nav-previouslyExported" (click)="statusChange(ExpenseStatusEnum.CCExpenseNotMatchedWithReceipt, null)">
        {{ "Unmatched With Receipts" | translate : param }}</a>
    </div>
  </nav>
</div> -->
<!-- <h5 *ngIf ="buttonFilterItem" class="fw-600">Items for Review (2 / 4)</h5> -->
<div class="outer-div">
    <div class="grid-wrapper {{gridWrapperClass}}"
         [ngStyle]="gridstyle"
         *ngIf="gridOptions">
        <ag-grid-angular #agGrid
                         [ngStyle]="gridWrapperstyle"
                         id="myGrid"
                         class="ag-theme-alpine"
                         [ngClass]="{'custom-hover': gridConfigItems.isHoverRowColumnHighlight}"
                         (gridReady)="onGridReady($event)"
                         (columnResized)="oncolumnResized($event)"
                         (cellClicked)="onCellClicked($event)"
                         [gridOptions]="gridOptions"
                         [suppressDragLeaveHidesColumns]="true"
                         [suppressMakeColumnVisibleAfterUnGroup]="true"
                         [rowGroupPanelShow]="rowGroupPanelShow"
                         [autoGroupColumnDef]="autoGroupColumnDef"
                         [enableRangeSelection]="false"
                         [groupHideOpenParents]="true"
                         [animateRows]="true"
                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                         [overlayLoadingTemplate]="overlayLoadingTemplate"
                         [pinnedBottomRowData]="pinnedBottomRowData"
                         [suppressRowHoverHighlight]="gridConfigItems.suppressRowHoverHighlight"
                         [columnHoverHighlight]="false">
        </ag-grid-angular>
    </div>
</div>




<div class="overLayDiv active" *ngIf="showAdvancedFilters"></div>
<div id="rightSideBar" style="z-index: 9999999;">
    <div class="rightSidePanel active" *ngIf="showAdvancedFilters">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{"advance_search" | translate}}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="closeAdvanceSearchPanel()">
                    {{ 'label_close' | translate}}
                </button>
            </div>
        </header>
        <div class="block mt-2 heightCalc-5 overflow-hidden">
            <section class="searchTotal mt-0">
                <div class="border-bottom padding-bottom-10">
                    <h6 class="color-orange mb-0 lH-normal">{{"name_search_text" | translate}} </h6>
                    <small class="d-block">({{"contacts_count_text" | translate}})</small>
                </div>
                <div class="xeroAdvFilter box-shadow">
                    <div class="d-flex justify-content-between">
                        <div class="w-100pc">
                            <ul class="letterList-A-F">
                                <li (click)="startsWith_A>0&&filterWithAdvanceFilter('A')">A <small>({{startsWith_A}})</small></li>
                                <li (click)="startsWith_B>0&&filterWithAdvanceFilter('B')">B <small>({{startsWith_B}})</small></li>
                                <li (click)="startsWith_C>0&&filterWithAdvanceFilter('C')">C <small>({{startsWith_C}})</small></li>
                                <li (click)="startsWith_D>0&&filterWithAdvanceFilter('D')">D <small>({{startsWith_D}})</small></li>
                                <li (click)="startsWith_E>0&&filterWithAdvanceFilter('E')">E <small>({{startsWith_E}})</small></li>
                                <li (click)="startsWith_F>0&&filterWithAdvanceFilter('F')">F <small>({{startsWith_F}})</small></li>
                            </ul>
                            <ul class="letterList-G-L">
                                <li (click)="startsWith_G>0&&filterWithAdvanceFilter('G')">G <small>({{startsWith_G}})</small></li>
                                <li (click)="startsWith_H>0&&filterWithAdvanceFilter('H')">H <small>({{startsWith_H}})</small></li>
                                <li (click)="startsWith_I>0&&filterWithAdvanceFilter('I')">I <small>({{startsWith_I}})</small></li>
                                <li (click)="startsWith_J>0&&filterWithAdvanceFilter('J')">J <small>({{startsWith_J}})</small></li>
                                <li (click)="startsWith_K>0&&filterWithAdvanceFilter('K')">K <small>({{startsWith_K}})</small></li>
                                <li (click)="startsWith_L>0&&filterWithAdvanceFilter('L')">L <small>({{startsWith_L}})</small></li>
                            </ul>
                            <ul class="letterList-M-R">
                                <li (click)="startsWith_M>0&&filterWithAdvanceFilter('M')">M <small>({{startsWith_M}})</small></li>
                                <li (click)="startsWith_N>0&&filterWithAdvanceFilter('N')">N <small>({{startsWith_N}})</small></li>
                                <li (click)="startsWith_O>0&&filterWithAdvanceFilter('O')">O <small>({{startsWith_O}})</small></li>
                                <li (click)="startsWith_P>0&&filterWithAdvanceFilter('P')">P <small>({{startsWith_P}})</small></li>
                                <li (click)="startsWith_Q>0&&filterWithAdvanceFilter('Q')">Q <small>({{startsWith_Q}})</small></li>
                                <li (click)="startsWith_R>0&&filterWithAdvanceFilter('R')">R <small>({{startsWith_R}})</small></li>
                            </ul>
                            <ul class="letterList-S-X">
                                <li (click)="startsWith_S>0&&filterWithAdvanceFilter('S')">S <small>({{startsWith_S}})</small></li>
                                <li (click)="startsWith_T>0&&filterWithAdvanceFilter('T')">T <small>({{startsWith_T}})</small></li>
                                <li (click)="startsWith_U>0&&filterWithAdvanceFilter('U')">U <small>({{startsWith_U}})</small></li>
                                <li (click)="startsWith_V>0&&filterWithAdvanceFilter('V')">V <small>({{startsWith_V}})</small></li>
                                <li (click)="startsWith_W>0&&filterWithAdvanceFilter('W')">W <small>({{startsWith_W}})</small></li>
                                <li (click)="startsWith_X>0&&filterWithAdvanceFilter('X')">X <small>({{startsWith_X}})</small></li>
                            </ul>
                            <ul class="letterList-Y-Z">
                                <li (click)="startsWith_Y>0&&filterWithAdvanceFilter('Y')">Y <small>({{startsWith_Y}})</small></li>
                                <li (click)="startsWith_Z>0&&filterWithAdvanceFilter('Z')">Z <small>({{startsWith_Z}})</small></li>
                                <li class="color-white disabled pointer-events-none">&nbsp;<small
                                            class="color-white">(20)</small></li>
                                <li class="color-white disabled pointer-events-none">&nbsp;<small
                                            class="color-white">(20)</small></li>
                                <li class="color-white disabled pointer-events-none">&nbsp;<small
                                            class="color-white">(20)</small></li>
                                <li class="color-white disabled pointer-events-none">&nbsp;<small
                                            class="color-white">(20)</small></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<!-- filter panel -->
<div class="overLayDiv active" *ngIf="gridConfigItems && gridConfigItems.gridFilterPanelConfig != null && showFilterPanel"></div>
<div id="rightSideBar" *ngIf="gridConfigItems && gridConfigItems.gridFilterPanelConfig != null && showFilterPanel">
    <div class="rightSidePanel d-flex flex-column w-40pc">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{'filter_by' | translate}}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="closeFilterPanel()">
                    {{'close' | translate}}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div class="block mt-2">
                <h6 class="note m-0 d-flex align-items-center justify-content-between gap-2"><span class="fw-700">{{gridConfigItems.gridFilterPanelConfig.panelHeader}}</span><span class="fw-700">{{gridConfigItems.gridFilterPanelConfig.panelHeaderCount}}</span></h6>
            </div>
            <div class="block mt-2" *ngFor="let item of gridConfigItems.gridFilterPanelConfig.sections">
                <h6 class="note d-flex align-items-center justify-content-between gap-2 border-bottom pb-2"><span class="fw-700">{{item.sectionHeader}}</span><span class="fw-700">{{item.sectionHeaderCount}}</span></h6>
                <div class="d-flex flex-column gap-2">
                    <div class="eod-filter-radio" *ngFor="let option of item.sectionOptions">
                        <input type="radio" required="" class="m-0 svg-20" [checked]="gridConfigItems.statusValue === option.optionValue" value="option.optionValue" (change)="statusChange(option.optionValue, ''); closeFilterPanel()">
                        <label for="employeeFirstName" class="filter-label">
                            <div class="label-text" (click)="statusChange(option.optionValue, ''); closeFilterPanel()">
                                <img [src]="option.optionIcon" alt="filter">
                                <span>{{option.optionName}}</span>
                            </div>
                            <span>{{option.optionCount}}</span>
                        </label>
                    </div>
                </div>        
            </div>
        </div>
    </div>
</div>
<!-- filter panel end-->
